import React from "react";
import { useNavigate } from "react-router-dom";
import { ExternalLink, Package } from "lucide-react";

interface SiteCardProps {
  id: string | number;
  name: string;
  url: string;
  productsCount?: number;
}

export const SiteCard: React.FC<SiteCardProps> = ({
  id,
  name,
  url,
  productsCount = 0,
}) => {
  const navigate = useNavigate();

  // Générer une couleur basée sur le nom du site
  const getColorFromName = (name: string) => {
    const colors = [
      "bg-primary-500",
      "bg-blue-500",
      "bg-green-500",
      "bg-yellow-500",
      "bg-red-500",
      "bg-indigo-500",
      "bg-pink-500",
      "bg-purple-500",
    ];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  // Obtenir la première lettre du nom
  const getInitial = (name: string) => {
    return name.charAt(0).toUpperCase();
  };

  const handleClick = () => {
    navigate(`/site/${id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer group"
    >
      <div className="p-4">
        {/* Avatar Circle */}
        <div className="flex justify-center mb-3">
          <div
            className={`w-16 h-16 ${getColorFromName(
              name
            )} rounded-full flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow`}
          >
            <span className="text-white text-2xl font-bold">
              {getInitial(name)}
            </span>
          </div>
        </div>

        {/* Site Name */}
        <h3 className="text-center text-base font-semibold text-gray-900 mb-1 truncate">
          {name}
        </h3>

        {/* Site URL */}
        <div className="flex items-center justify-center gap-1 mb-3">
          <ExternalLink size={12} className="text-gray-400" />
          <p className="text-xs text-gray-500 truncate">{url}</p>
        </div>

        {/* Products Count */}
        <div className="flex items-center justify-center gap-2 pt-3 border-t border-gray-100">
          <Package size={14} className="text-gray-400" />
          <span className="text-xs font-medium text-gray-600">
            {productsCount} produit{productsCount !== 1 ? "s" : ""}
          </span>
        </div>
      </div>
    </div>
  );
};
